import React, { useMemo } from "react";
import { list, add, update, deleteParticipant } from "../../../client/api/participants";
import { Participant } from "common/build/prisma/client";
import { CrudProvider } from "../../../core/components/crud/contexts/crud.context";
import { ListProvider } from "../../../core/components/crud/contexts/list.context";
import { ProgrammeParticipantAdd } from "./ProgrammeParticipantAdd";
import { ProgrammeParticipantList } from "./ProgrammeParticipantList";
import { createProgrammeParticipantCRUDModel } from "./model";
import { Grid } from "@mui/material";
import { ParticipantListParameters } from "../../../../../common/build/api-parameters/participants";
import { useFetch } from "../../../core/components/crud/contexts/fetch.context";
import { ProgrammeType } from "../../../models/modelTypes";

type ProgrammeParticipantScreenProps = {
    programmeId: number;
};

export const ProgrammeParticipantScreen = (props: ProgrammeParticipantScreenProps): JSX.Element => {
    const { programmeId } = props;

    const { item, fetching } = useFetch<ProgrammeType>();

    const model = useMemo(() => createProgrammeParticipantCRUDModel(item), [item]);

    const listParams: ParticipantListParameters = { programmeId, take: 100 };
    return (
        <>
            <CrudProvider<Participant>
                model={model}
                noun="Participant"
                addItem={add}
                updateItem={update}
                deleteData={deleteParticipant}
            >
                <ListProvider plural={"Participants"} includes={listParams} getData={list} pagination={false}>
                    <ProgrammeParticipantList programmeId={programmeId} />

                    <Grid item xs={12}>
                        {!fetching && item && (
                            <ProgrammeParticipantAdd programmeId={programmeId} isOneToOne={item.isGroup === false} />
                        )}
                    </Grid>
                </ListProvider>
            </CrudProvider>
        </>
    );
};
